import { combineReducers } from 'redux';
import { loadingBarReducer } from 'react-redux-loading-bar';

import stepsReducer from "./stepsReducer";
import selectionReducer from "./selectionReducer";
import serverReducer from "./serverReducer";
import bathroomVisualizerReducer from "./bathroomVisualizerReducer";
import loaderReducer from "./loaderReducer";
import userReducer from "./userReducer";
import cartReducer from "./cartReducer";
import instReducer from "./instReducer";
import messageBoxReducer from "./messageBoxReducer";
import filterReducer from './filterReducer';
import navigationReducer from './navigationReducer';
import fabricatorReducer from './fabricatorReducer';
import sqftReducer from './sqft/sqftReducer';
import docuSignReducer from './docuSignReducer';
import qtReducer from './qtReducer';
import tutorialReducer from './tutorialReducer';
import contractSigningReducer from "./contractSigningReducer";
import initialFlowReducer from "./initialFlowReducer";
import priceWorksheetReducer from "./priceWorksheetReducer";
import unlockCalculationsReducer from "./unlockCalculationsReducer";
import quotesReducer from "./quotesReducer";
import advancedQuotingReducer from "./advancedQuotingReducer";
import assignQuoteReducer from "./assignQuoteReducer";
import printReducer from "./printReducer";
import wizardReducer from "./wizardReducer";
import sqftMenuReducer from "./sqft/sqftMenuReducer";
import sqftManualCalculationReducer from "./sqft/sqftManualCalculationReducer";
import sqftSlabReducer from "./sqft/sqftSlabReducer";
import sqftResourcesReducer from "./sqft/sqftResourcesReducer";
import sqftMiteredReducer from "./sqft/sqftMiteredReducer";
import lookReducer from "./lookReducer";
import groheReducer from "./groheReducer";
import iframeIntegrationReducer from "./iframeIntegrationReducer";
import groheQuotingToolReducer from "./groheQuotingToolReducer";
import paymentReducer from "./paymentReducer";
import historyReducer from "./historyReducer";
import shopReducer from "./shopReducer";
import sqftTutorialReducer from "./sqft/sqftTutorialReducer";
import adminReducer from "../bvcomponents/qkbPages/superAdmin/adminReducer";
import aiReducer from "../bvcomponents/ai/aiReducer";
import sqftFeatureGridReducer from "./sqft/sqftFeatureGridReducer";
import sqftModalFixReducer from "./sqft/sqftModalFixReducer";
import sqftTooltipReducer from "./sqft/sqftTooltipReducer";

// Combine Reducers
export const reducers = combineReducers({
  adminState: adminReducer,
  aiState: aiReducer,
  advancedQuotingState: advancedQuotingReducer,
  assignQuoteState: assignQuoteReducer,
  bathroomVisualizerState: bathroomVisualizerReducer,
  cartState: cartReducer,
  contractSigningState: contractSigningReducer,
  docuSignState: docuSignReducer,
  fabricatorState: fabricatorReducer,
  filterState: filterReducer,
  groheQuotingToolState: groheQuotingToolReducer,
  groheState: groheReducer,
  historyState: historyReducer,
  iframeIntegrationState: iframeIntegrationReducer,
  initialFlowState: initialFlowReducer,
  instState: instReducer,
  loaderState: loaderReducer,
  loadingBar: loadingBarReducer,
  lookState: lookReducer,
  messageBoxState: messageBoxReducer,
  navigationState: navigationReducer,
  paymentState: paymentReducer,
  priceWorksheetState: priceWorksheetReducer,
  printState: printReducer,
  qtState: qtReducer,
  quotesState: quotesReducer,
  selectionState: selectionReducer,
  serverState: serverReducer,
  shopState: shopReducer,
  sqftManualCalculationState: sqftManualCalculationReducer,
  sqftMenuState: sqftMenuReducer,
  sqftModalFixState: sqftModalFixReducer,
  sqftMiteredState: sqftMiteredReducer,
  sqftResourceState: sqftResourcesReducer,
  sqftSlabState: sqftSlabReducer,
  sqftState: sqftReducer,
  sqftTutorialState: sqftTutorialReducer,
  sqftTooltipState: sqftTooltipReducer,
  sqftFeatureGridReducer : sqftFeatureGridReducer,
  stepsState: stepsReducer,
  tutorialState: tutorialReducer,
  unlockCalculationsState: unlockCalculationsReducer,
  userState: userReducer,
  wizardState: wizardReducer
});

